import { ReactElement } from 'react';
import {
    Gender,
    IMySavedItem,
    IMySavedItemsList,
    IPhysicalStore,
    PersonalDetails,
    PersonalDetailsAddressType,
    PersonalDetailsGeographicInformations,
    PersonalInformation,
} from '@interfaces/myProfileInterfaces';

import {
    IContactLensDetails as IContactLensDetails,
    IContactLensAttributes,
    IMySavedPrescriptionItem,
    IMappedContactLensList,
    IMappedContactLensItem,
    IDoctorList,
    IDoctorListItem
} from '@interfaces/myAppointmentInterfaces';

import VisaLogo from '@images/svg-icons/visaLogo.svg';
import MastercardLogo from '@images/svg-icons/mastercardLogo.svg';
import AmexLogo from '@images/svg-icons/amexLogo.svg';
import JcbLogo from '@images/svg-icons/jcbLogo.svg';
import DiscoverLogo from '@images/svg-icons/discoverLogo.svg';
import { LOGON_ID_STORE } from '@utils/const';
import { convertDate, getMockedFile, getFormattedNumber } from '@utils/utils';
import URLS from '@utils/urlList';
import axios, { AxiosRequestConfig } from 'axios';

////////// PERSONAL DETAILS //////////

const getFirstName = (data: any) => {
    let firstName;
    if (!!data) {
        data.map(element => {
            if (element.pProfileAttrKey === 'demographicField7') {
                firstName = element.pProfileAttrValue;
            }
        });
    }
    return firstName;
};

const getLastName = (data: any) => {
    let lastName;
    if (!!data) {
        data.map(element => {
            if (element.pProfileAttrKey === 'demographicField5') {
                lastName = element.pProfileAttrValue;
            }
        });
    }
    return lastName;
};

const getPhone = (data: any) => {
    let phone;
    if (!!data) {
        data.map(element => {
            if (element.pProfileAttrKey === 'userProfileField2') {
                phone = element.pProfileAttrValue;
            }
        });
    }
    return phone;
};

const getGender = (data: string): string => {
    let gender = '';

    if (!!data) {
        switch (data.toLowerCase()) {
            case 'male':
                gender = 'M';
                break;
            case 'female':
                gender = 'F';
                break;
            default:
                gender = 'N';
                break;
        }
    }

    return gender;
};

//DESCRIPTIVE_PERSONALIZATION_SETTINGS_TYPES understood if to add
const getPersonalizationSettings = (data: any) => {
    let arrayPersonalization = {};
    STYLE_PERSONALIZATION_SETTINGS_TYPES.map(element => {
        arrayPersonalization[element] = false;
    });
    OTHERS_PERSONALIZATION_SETTINGS_TYPES.map(element => {
        arrayPersonalization[element] = false;
    });
    BRAND_PERSONALIZATION_SETTINGS_TYPES.map(element => {
        arrayPersonalization[element] = false;
    });
    SHAPE_PERSONALIZATION_SETTINGS_TYPES.map(element => {
        arrayPersonalization[element] = false;
    });
    VISIONCARE_PERSONALIZATION_SETTINGS_TYPES.map(element => {
        arrayPersonalization[element] = false;
    });
    WHO_PERSONALIZATION_SETTINGS_TYPES.map(element => {
        arrayPersonalization[element] = false;
    });
    if (!!data) {
        data.map(element => {
            if (
                STYLE_PERSONALIZATION_SETTINGS_TYPES.some(substring =>
                    element.attributeName.includes(substring)
                )
            ) {
                arrayPersonalization[element.attributeName] =
                    element.attributeValue[0].value[0] === 'true';
            } else if (
                OTHERS_PERSONALIZATION_SETTINGS_TYPES.some(substring =>
                    element.attributeName.includes(substring)
                )
            ) {
                arrayPersonalization[element.attributeName] =
                    element.attributeValue[0].value[0] === 'true';
            }else if (
                BRAND_PERSONALIZATION_SETTINGS_TYPES.some(substring =>
                    element.attributeName.includes(substring)
                )
            ) {
                arrayPersonalization[element.attributeName] =
                    element.attributeValue[0].value[0] === 'true';
            }else if (
                SHAPE_PERSONALIZATION_SETTINGS_TYPES.some(substring =>
                    element.attributeName.includes(substring)
                )
            ) {
                arrayPersonalization[element.attributeName] =
                    element.attributeValue[0].value[0] === 'true';
            }else if (
                VISIONCARE_PERSONALIZATION_SETTINGS_TYPES.some(substring =>
                    element.attributeName.includes(substring)
                )
            ) {
                arrayPersonalization[element.attributeName] =
                    element.attributeValue[0].value[0] === 'true';
            }else if (
                WHO_PERSONALIZATION_SETTINGS_TYPES.some(substring =>
                    element.attributeName.includes(substring)
                )
            ) {
                arrayPersonalization[element.attributeName] =
                    element.attributeValue[0].value[0] === 'true';
            }
        });
    }
    return arrayPersonalization;
};

export const mapPersonalInformation = (data: any): PersonalInformation => {
    let dob = null;
    if (!!data.dateOfBirth) {
        if (data.dateOfBirth[data.dateOfBirth.length - 1] === 'Z') {
            dob = new Date(data.dateOfBirth.slice(0, -1));
        } else {
            dob = new Date(data.dateOfBirth);
        }
        dob = dob.toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
        });
        dob = new Date(dob);
    }
    return {
        firstname: getFirstName(data.attributes),
        lastname: getLastName(data.attributes),
        email: !!data.logonId && data.logonId.replace(LOGON_ID_STORE, ''),
        dob: dob,
        gender: getGender(data?.gender),
        phone1: getPhone(data.attributes),
        personalizationSettings: getPersonalizationSettings(data.contextAttribute),
    };
};

export const mapPersonalDetails = (data: any): PersonalDetails => {
    return {
        addressId: data?.addressId,
        shipaddressId: data?.shipaddressId,
        oldAddressType: data?.oldAddressType,
        billingAddress: {
            firstName: getFirstName(data.attributes), //data?.billingAddress?.firstName, // getFirstName(data?.attribues),
            lastName: getLastName(data.attributes), //data?.billingAddress?.lastName, //getLastName(data?.attribues),
            addressLine1: data?.billingAddress?.addressLine1,
            addressLine2: data?.billingAddress?.addressLine2,
            zipcode: data?.billingAddress?.zipcode,
            city: data?.billingAddress?.city,
            state: data?.billingAddress?.state,
        },
        sameShippingAndBillingAddressCustom: data?.SameShippingAndBillingAddressCustom,
        shippingAddress: {
            firstName: data?.shippingAddress?.firstName,
            lastName: data?.shippingAddress?.lastName,
            addressLine1: data?.shippingAddress?.addressLine1,
            addressLine2: data?.shippingAddress?.addressLine2,
            zipcode: data?.shippingAddress?.zipcode,
            city: data?.shippingAddress?.city,
            state: data?.shippingAddress?.state,
        },
        email: !!data.logonId && data.logonId.replace(LOGON_ID_STORE, ''), //prendere 12001 in modo dinamico
        phone1: {
            phoneNumber: data?.phone1?.phoneNumber,
            phoneType: data?.phone1?.phoneType,
        },
        phone2: {
            phoneNumber: data?.phone2?.phoneNumber,
            phoneType: data?.phone2?.phoneType,
        },
        dob: !!data.dateOfBirth && new Date(data.dateOfBirth.split('T')[0]).toISOString(),
        gender: data?.gender,
    };
};

/** The function below returns the city and the state from the given zip code */

export const mapGeographicInformations = (
    data: any,
    addressType: PersonalDetailsAddressType
): PersonalDetailsGeographicInformations => {
    const city = data?.find(address => address.types[0] === 'locality')?.long_name;
    const state = data?.find(
        address => address.types[0] === 'administrative_area_level_1'
    )?.short_name;
    const cityControl = data?.find(
        address => address.types[0] === 'administrative_area_level_3'
    )?.long_name;
    const finalCity = city ? city : cityControl;
    return finalCity && state
        ? {
              city: finalCity,
              state: state,
              ...((finalCity || state) && { addressType: addressType }),
          }
        : undefined;
};

interface PersonalizationSettingsConfig {
    label: string;
    value: boolean;
}

////////// STYLE PERSONALIZATION SETTINGS //////////

export const STYLE_PERSONALIZATION_SETTINGS_TYPES = [
    'womenStyle',
    'menStyle',
    'childrenStyle',
    'contacts',
    'multiLenses',
    'blueLight',
] as const;

export const BRAND_PERSONALIZATION_SETTINGS_TYPES = [
    'rayBan',
    'armaniExchange',
    'coach',
    'vogueEyewear',
    'oakley',
    'ralph',
    'arnette',
    'aNewDay',
] as const;

export const SHAPE_PERSONALIZATION_SETTINGS_TYPES = [
    'rectangle',
    'catEye',
    'oval',
    'square',
    'round',
    'pilot',
    'geometric',
] as const;

export const VISIONCARE_PERSONALIZATION_SETTINGS_TYPES = [
    'sun',
    'frameSingleVision',
    'contacts',
    'childrenStyle',
    'multiLenses',
    'blueLight',
    'transition',
] as const;

export const WHO_PERSONALIZATION_SETTINGS_TYPES = [
    'justMe',
    'partner',
    'under12',
    'twelveto18',
] as const;

type StylePersonalizationSettingsTypes = typeof STYLE_PERSONALIZATION_SETTINGS_TYPES[number];
type BrandPersonalizationSettingsTypes = typeof BRAND_PERSONALIZATION_SETTINGS_TYPES[number];
type ShapePersonalizationSettingsTypes = typeof SHAPE_PERSONALIZATION_SETTINGS_TYPES[number];
type VisionCarePersonalizationSettingsTypes = typeof VISIONCARE_PERSONALIZATION_SETTINGS_TYPES[number];
type WhoPersonalizationSettingsTypes = typeof WHO_PERSONALIZATION_SETTINGS_TYPES[number];

export type StylePersonalizationSettingsConfig = {
    [key in StylePersonalizationSettingsTypes]: PersonalizationSettingsConfig;
};

export type BrandPersonalizationSettingsConfig = {
    [key in BrandPersonalizationSettingsTypes]: PersonalizationSettingsConfig;
};

export type ShapePersonalizationSettingsConfig = {
    [key in ShapePersonalizationSettingsTypes]: PersonalizationSettingsConfig;
};

export type VisionCarePersonalizationSettingsConfig = {
    [key in VisionCarePersonalizationSettingsTypes]: PersonalizationSettingsConfig;
};

export type WhoPersonalizationSettingsConfig = {
    [key in WhoPersonalizationSettingsTypes]: PersonalizationSettingsConfig;
};

export const DEFAULT_STYLE_SETTINGS: StylePersonalizationSettingsConfig = {
    womenStyle: {
        label: 'SETTINGS_STYLE_PERSONALIZATION_SETTINGS_WOMEN',
        value: false,
    },
    menStyle: {
        label: 'SETTINGS_STYLE_PERSONALIZATION_SETTINGS_MEN',
        value: false,
    },
    childrenStyle: {
        label: 'SETTINGS_STYLE_PERSONALIZATION_SETTINGS_CHILDREN',
        value: false,
    },
    contacts: {
        label: 'SETTINGS_STYLE_PERSONALIZATION_SETTINGS_CONTACT_LENSES',
        value: false,
    },
    multiLenses: {
        label: 'SETTINGS_STYLE_PERSONALIZATION_SETTINGS_MULTI_LENSES',
        value: false,
    },
    blueLight: {
        label: 'SETTINGS_STYLE_PERSONALIZATION_SETTINGS_BLUE_LIGHT',
        value: false,
    },
};

export const DEFAULT_BRAND_SETTINGS: BrandPersonalizationSettingsConfig = {
    rayBan: {
        label: 'SETTINGS_BRAND_PERSONALIZATION_SETTINGS_RAYBAN',
        value: false,
    },
    armaniExchange: {
        label: 'SETTINGS_BRAND_PERSONALIZATION_SETTINGS_ARMANI',
        value: false,
    },
    coach: {
        label: 'SETTINGS_BRAND_PERSONALIZATION_SETTINGS_COACH',
        value: false,
    },
    vogueEyewear: {
        label: 'SETTINGS_BRAND_PERSONALIZATION_SETTINGS_VOGUE_EYEWEAR',
        value: false,
    },
    oakley: {
        label: 'SETTINGS_BRAND_PERSONALIZATION_SETTINGS_OAKLEY',
        value: false,
    },
    ralph: {
        label: 'SETTINGS_BRAND_PERSONALIZATION_SETTINGS_RALPH',
        value: false,
    },
    arnette: {
        label: 'SETTINGS_BRAND_PERSONALIZATION_SETTINGS_ARNETTE',
        value: false,
    },
    aNewDay: {
        label: 'SETTINGS_BRAND_PERSONALIZATION_SETTINGS_ANEWDAY',
        value: false,
    },
};


export const DEFAULT_SHAPE_SETTINGS: ShapePersonalizationSettingsConfig = {
    rectangle: {
        label: 'SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_RECTANGLE',
        value: false,
    },
    catEye: {
        label: 'SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_CATEYE',
        value: false,
    },
    oval: {
        label: 'SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_OVAL',
        value: false,
    },
    square: {
        label: 'SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_SQUARE',
        value: false,
    },
    round: {
        label: 'SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_ROUND',
        value: false,
    },
    pilot: {
        label: 'SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_PILOT',
        value: false,
    },
    geometric: {
        label: 'SETTINGS_SHAPE_PERSONALIZATION_SETTINGS_GEOMETRIC',
        value: false,
    },
};


export const DEFAULT_VISON_CARE_SETTINGS: VisionCarePersonalizationSettingsConfig = {
    sun: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_SUN',
        value: false,
    },

    frameSingleVision: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_FRAMES',
        value: false,
    },
    contacts: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_CONTACTLENSES',
        value: false,
    },
    childrenStyle: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_CHILDRENSTYLE',
        value: false,
    },
    multiLenses: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_PRESCRIPTION',
        value: false,
    },
    blueLight: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_BLUELIGHT',
        value: false,
    },
    transition: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_TRANSITION',
        value: false,
    },
};


export const DEFAULT_WHO_SETTINGS: WhoPersonalizationSettingsConfig = {
    justMe: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_JUSTME',
        value: false,
    },
    partner: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_MYPARTNER',
        value: false,
    },
    under12: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_ONECHILD',
        value: false,
    },
    twelveto18: {
        label: 'SETTINGS_VISIONCARE_PERSONALIZATION_SETTINGS_TEEN',
        value: false,
    },
};

////////// DESCRIPTIVE PERSONALIZATION SETTINGS //////////

export const DESCRIPTIVE_PERSONALIZATION_SETTINGS_TYPES = [
    'jewelry',
    'durable',
    'look',
    'yearlyExam',
    'participateActivities',
    'sameStyle',
    'shopAlone',
    'expression',
    'needHelp',
    'largeFace',
    'smallFace',
    'narrowNose',
    'wideNose',
] as const;

type DescriptivePersonalizationSettingsTypes =
    typeof DESCRIPTIVE_PERSONALIZATION_SETTINGS_TYPES[number];

export type DescriptivePersonalizationSettingsConfig = {
    [key in DescriptivePersonalizationSettingsTypes]: PersonalizationSettingsConfig;
};

export const DEFAULT_DESCRIPTIVE_SETTINGS: DescriptivePersonalizationSettingsConfig = {
    jewelry: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_JEWELERY',
        value: false,
    },
    durable: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_HOW_MUCH',
        value: false,
    },
    look: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_LOOK',
        value: false,
    },
    yearlyExam: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_YEARLY_EXAM',
        value: false,
    },
    participateActivities: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_PARTECIPATE_ACTIVITIES',
        value: false,
    },
    sameStyle: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_SAME_STYLE',
        value: false,
    },
    shopAlone: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_SHOP_ALONE',
        value: false,
    },
    expression: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_EXPRESSION',
        value: false,
    },
    needHelp: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_NEED_HELP',
        value: false,
    },
    largeFace: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_LARGE_FACE',
        value: false,
    },
    smallFace: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_SMALL_FACE',
        value: false,
    },
    narrowNose: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_NARROW_NOSE',
        value: false,
    },
    wideNose: {
        label: 'SETTINGS_DESCRIPTIVE_PERSONALIZATION_SETTINGS_WIDE_NOSE',
        value: false,
    },
};

////////// OTHERS PERSONALIZATION SETTINGS //////////

export const OTHERS_PERSONALIZATION_SETTINGS_TYPES = [
    'justMe',
    'partner',
    'under12',
    'twelveto18',
] as const;

type OthersPersonalizationSettingsTypes = typeof OTHERS_PERSONALIZATION_SETTINGS_TYPES[number];

export type OthersPersonalizationSettingsConfig = {
    [key in OthersPersonalizationSettingsTypes]: PersonalizationSettingsConfig;
};

export const DEFAULT_OTHERS_SETTINGS: OthersPersonalizationSettingsConfig = {
    justMe: {
        label: 'SETTINGS_OTHERS_PERSONALIZATION_SETTINGS_JUST_ME',
        value: false,
    },
    partner: {
        label: 'SETTINGS_OTHERS_PERSONALIZATION_SETTINGS_MY_PARTNER',
        value: false,
    },
    under12: {
        label: 'SETTINGS_OTHERS_PERSONALIZATION_SETTINGS_UNDER_TWELVE',
        value: false,
    },
    twelveto18: {
        label: 'SETTINGS_OTHERS_PERSONALIZATION_SETTINGS_TWELVE_TO_EIGHTEEN',
        value: false,
    },
};

export const mapFavouritesStoresList = (data: any): IPhysicalStore[] => {
    return (
        data?.map((item: any) =>
            item?.PhysicalStore ? mapPhysicalStore(item.PhysicalStore[0]) : null
        ) ?? []
    );
};

export const mapPhysicalStore = (data: any): IPhysicalStore => {
    return {
        uniqueID: data?.uniqueID,
        x_preferredStoreNumber: data?.x_preferredStoreNumber,
        telephone1: data?.telephone1,
        addressLine: data?.addressLine?.[0],
        stateOrProvinceName: data?.stateOrProvinceName,
        city: data?.city,
        country: data?.country,
        postalCode: data?.postalCode,
        storeName: data?.Description?.[0]?.displayStoreName,
        storeHours:
            data?.Attribute?.find(attribute => attribute?.displayName === 'StoreHours')
                ?.displayValue ?? null,
        longitude: data?.longitude,
        latitude: data?.latitude,
        storeIdentifier: data?.storeName,
        isBookingAppt: data?.Attribute?.find(
            attribute => attribute?.displayName === 'bookingAppt' && attribute?.displayValue === 'Y'
        ),
    };
};

////////// MY STORES //////////

export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
export type WeekDays = typeof WEEKDAYS[number];

export const MY_STORES_PLACEHOLDERS_QUERY_PARAMS = [
    'storeNumber',
    'catalogId',
    'langId',
    'storeId',
] as const;
type MyStoresPlaceHoldersQueryParamsTypes = typeof MY_STORES_PLACEHOLDERS_QUERY_PARAMS[number];
export type MyStoresPlaceHoldersQueryParamsConfig = {
    [key in MyStoresPlaceHoldersQueryParamsTypes]: string;
};

/** The belows function sorts the favourites stores */
export const getSortedArray = (favouritesStores: IPhysicalStore[]): IPhysicalStore[] => {
    return favouritesStores.sort(
        (a, b) => parseInt(a.x_preferredStoreNumber) - parseInt(b.x_preferredStoreNumber)
    );
};

/** Get the full physical store address */

export const getFullAddress = (physicalStore: IPhysicalStore): string => {
    return `${physicalStore.addressLine}, ${physicalStore.city}, ${physicalStore.stateOrProvinceName}, ${physicalStore.postalCode}`;
};

/** The function below checks if a value is value of Gender type */
export const isOfTypeGender = (value: string): value is Gender => {
    return ['M', 'F', 'N'].includes(value);
};

////////// PAYMENT METHODS //////////

export const CREDIT_CARDS = ['VISA', 'MASTERCARD', 'AMEX', 'JCB', 'DISCOVER'] as const;

type CreditCardsTypes = typeof CREDIT_CARDS[number];

export type CreditCardsLogos = { [key in CreditCardsTypes]: ReactElement };

export const CREDIT_CARDS_LOGOS: CreditCardsLogos = {
    VISA: <VisaLogo />,
    MASTERCARD: <MastercardLogo />,
    AMEX: <AmexLogo />,
    JCB: <JcbLogo />,
    DISCOVER: <DiscoverLogo />,
};

////////// MY SAVED ITEMS //////////

/** The functions below returns the most recent mapped saved item */

export const mapSavedItemsList = (data: any): IMySavedItemsList => {
    const savedItem = data?.savedItems[0].catentries.find(element =>
        ['EYE', 'SUN', 'LCON', 'RCON'].includes(element.catEntryType)
    );
    return {
        totalCount: data?.totalCount,
        totalPrice: `${
            savedItem?.currency
                ? ['USD', 'CAD'].includes(savedItem.currency.toUpperCase())
                    ? '$'
                    : savedItem.currency
                : ''
        }${Number(savedItem?.listPrice).toFixed(2)}`,
        totalDiscountedPrice: `${
            savedItem?.currency
                ? ['USD', 'CAD'].includes(savedItem.currency.toUpperCase())
                    ? '$'
                    : savedItem.currency
                : ''
        }${Number(savedItem?.offerPrice).toFixed(2)}`,
        totalPercentageOff:
            savedItem?.totalPercentageOff ||
            (savedItem?.listPrice !== savedItem?.offerPrice
                ? (
                      ((Number(savedItem?.listPrice) - Number(savedItem?.offerPrice)) /
                          Number(savedItem?.listPrice)) *
                      100.0
                  ).toFixed(0)
                : null),
        savedItem: mapSavedItem(savedItem),
    };
};

export const mapSavedItem = (data: any): IMySavedItem => {
    return {
        brandName: data.attributes.find(element => element.name === 'brand')?.value,
        productName: data.attributes.find(element => element.name === 'name')?.value,
        imgUrl: data.attributes.find(element => element.name === 'imageUrl')?.value,
        modelName: data.attributes.find(element => element.name === 'model_name')?.value
    };
};

/** The function below checks if the zipcode is valid for CA or US country */

export const isValidZipCode = (zipcode: string, config: any): boolean => {
    switch (config.countryName.toUpperCase()) {
        case 'CA':
            return zipcode.length === 7 && /^[A-Za-z]\d[A-Za-z][ ]\d[A-Za-z]\d$/.test(zipcode);
        case 'US':
            return zipcode.length === 5;
        default:
            return false;
    }
};

export const isValidPhoneNumber = (phoneNumber: string) => {
    return !!phoneNumber && phoneNumber.replace('(+1)', '').replace(/\D/g, '').length >= 10;
};

// MY PRESCRIPTIONS IMPORT

////////// MY SAVED PRESCRIPTIONS //////////

/** The functions below returns the most recent mapped saved prescriptions */

export const mapSavedPrescriptionsList = (data: any): IMySavedPrescriptionItem[] => {
    return data.map(element => {
        return {
            ...mapSavedPrescription(element),
        };
    });
};

export const mapSavedPrescription = (data: any): IMySavedPrescriptionItem => {
    return {
        prescriptionId: data.prescriptionId,
        prescriptionName: data.prescriptionName,
        prescriptionType: data.prescriptionType,
        expiration: data.expiration,
        hasRelatedOrderPrescriptions: data.hasRelatedOrderPrescriptions,
        firstName: data.firstName,
        lastName: data.lastName,
        birthDate: data.birthDate,
        productCategory: data.productCategory,
        rightPicture: data.rightPicture,
        leftPicture: data.leftPicture,
        brandCLLeft: data.brandCLLeft,
        brandCLRight: data.brandCLRight,
        prescriptionValue: {
            rightSphere: data.rightSphere,
            leftSphere: data.leftSphere,
            leftCyl: data.leftCyl,
            rightCyl: data.rightCyl,
            rightAxis: data.rightAxis,
            leftAxis: data.leftAxis,
            rightAdd: data.rightAdd,
            leftAdd: data.leftAdd,
            pupillaryDistance: data.pupillaryDistance,
            pdRight: data.rpDistance,
            pdLeft: data.lpDistance,
            rightDia: data.rightDia,
            leftDia: data.leftDia,
            rightBC: data.rightBC,
            leftBC: data.leftBC,
            rightDominance: data.rightDominance,
            leftDominance: data.leftDominance,
        },
        prism: {
            prismEnable: data.prismEnable === 'true',
            odVPrism: data.odVPrism,
            osVPrism: data.osVPrism,
            odHPrism: data.odHPrism,
            osHPrism: data.osHPrism,
            odVPrismBaseDir: data.odVPrismBaseDir,
            osVPrismBaseDir: data.osVPrismBaseDir,
            odHPrismBaseDir: data.odHPrismBaseDir,
            osHPrismBaseDir: data.osHPrismBaseDir,
        },
        lastUpdate: data.lastUpdate,
        lastCreate: data.lastCreate,
        leftCatentryId: data.leftCatentryId,
        leftCatentryParentId: data.leftCatentryParentId,
        rightCatentryId: data.rightCatentryId,
        rightCatentryParentId: data.rightCatentryParentId,
        doctor: data.doctor,
        doctorAddress: data.doctorAddress,
        telephone: data.telephone,
        doctorFax: data.doctorFax,
        clinic: data.clinic,
        fileName: data.fileName,
        statePrescription: data.statePrescription,
        prescriptionOriginMode: data.prescriptionOriginMode,
        isVisible: data.isVisible,
        sameparent: data.sameParent,
        nameCLRight: data.nameCLRight,
        nameCLLeft: data.nameCLLeft,
        partnumber: data.partnumber,
        buyableCLRight: data.buyableCLRight,
        buyableCLLeft: data.buyableCLLeft,
        isPublishedCLLeft: data.isPublishedCLLeft,
        isPublishedCLRight: data.isPublishedCLRight,
        comment: data.comment,
    };
};

////////// SEARCH CONTACT LENSES //////////

/**
 * Search contact lenses
 * @param isMockRequest
 * @param storeId
 * @param catalogId
 * @param categoryId
 * @param searchTerm
 * @returns
 */
export const searchContactLenses = async (
    isMockRequest: boolean,
    storeId: string,
    catalogId: string,
    categoryId: string,
    searchTerm: string
) => {
    var mappedContactLensList: IMappedContactLensList = [];

    if (isMockRequest) {
        const searchCLMock = '/data/mocks/search_contact_lenses_mock.json';

        const response = await getMockedFile(searchCLMock);

        mappedContactLensList = mapRetrievedContactLenses(response.data);

        return mappedContactLensList;
    } else {
        const searchCLUrl = URLS.SEARCH_CONTACT_LENSES.replace(/{storeId}/g, storeId)
            .replace(/{catalogId}/g, catalogId)
            .replace(/{searchTerm}/g, searchTerm)
            .replace('{categoryId}', categoryId)
            .replace('{noCache}', new Date().getTime().toString());

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: searchCLUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        const response = await axios(config);

        mappedContactLensList = mapRetrievedContactLenses(response.data);

        return mappedContactLensList;
    }
};

export const mapRetrievedContactLenses = (data: any): IMappedContactLensList => {
    var mappedContactLensList: IMappedContactLensList = [];

    for (var element of data.catalogEntryView) {
        var modelName = (Object.values(element.attributes).find(
            (attribute: any) => attribute?.identifier === 'MODEL_NAME'
        ))?.values[0]?.value; 

        var mappedProduct: IMappedContactLensItem = {
            productId: element.uniqueID,
            productImageUrl:
                'https://assets.targetoptical.com/extra/image/TargetOptical/contacts_pim/' +
                element.partNumber +
                '_fr.png',
            productName: !!modelName ? modelName : 'default',
        };

        mappedContactLensList.push(mappedProduct);
    }

    return mappedContactLensList;
};

//MAP CL DETAILS
export const mapContactLensDetails = (data: any): IContactLensDetails => {
    return {
        id: data?.catalogEntryIdentifier?.uniqueId,
        parentId: data?.catalogEntryIdentifier?.parentProductId,
        name: data?.description[0]?.model,
        brand: data?.description[0]?.brand,
        image: data?.description[0]?.fullImage,
        partNumber: data?.description[0]?.name,
        attributes: mapContactLensAttributes(data?.attributes || data?.catalogEntry?.attributes),
        price: data?.offerPrice.slice(1),
        //attributes: data?.attributes
    };
};

export const mapContactLensAttributes = (attributes): IContactLensAttributes => {
    return {
        power: attributes?.CL_SPHERE_POWER,
        baseCurve: attributes?.CL_BASE_CURVE,
        cylinder: attributes?.CL_CYLINDER,
        axis: attributes?.CL_AXIS,
        diameter: attributes?.CL_DIAMETER,
        add: attributes?.CL_ADDITION,
        color: attributes?.CL_COLOR,
        dominance: attributes?.CL_DOMINANCE,
    };
};

//GET DOCTOR
export const mapDoctorList = (data: any): IDoctorList => {
    return data.map(element => {
        return {
            ...mapDoctorElement(element),
        };
    });
};

export const mapDoctorElement = (data: any): IDoctorListItem => {
    return {
        name: data.doctorName,
        phoneNumber: getFormattedNumber(data.doctorPhoneNumber),
        officePhoneNumber: getFormattedNumber(data.doctorOfficeNumber),
        faxNumber: getFormattedNumber(data.doctorFaxNumber),
        officeName: data.officeName,
        isOpenSaturday: data.isOpenSaturday,
        isValidDoctor: data.isValidDoctor,
        address: {
            address1: data.doctorAddress?.address1,
            address2: data.doctorAddress?.address2,
            city: data.doctorAddress?.city,
            zipPostalCode: data.doctorAddress?.zipPostalCode,
            state: data.doctorAddress?.stateProvince,
            country: data.doctorAddress?.country,
        },
    };
};